import { Box, Link, Paper, Typography } from '@mui/material';
import { NavLinkComponent } from '../../Router';
import { DataListComponent, NoDataPaper } from '../../components/data/DataTable';
import { locationTypes } from '../../models/Enums';
import { Location } from '../../models/Types';


const styles = {
    mobileIconWrapper: {
        p: .66,
        display: 'flex',
        borderRadius: .5
    },
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildLocationListItem(x: Location) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['id', x.Id]]}>
        <Box>
            <Link variant="h3">{x.Address}</Link>
            <Typography variant="subtitle2">{x.Type ? locationTypes[x.Type] : null}</Typography>
        </Box>
    </Paper>;
}

export function noDataRenderer() {
    return <NoDataPaper title="Платежей пока нет" content={['В этом разделе будут отображаться платежи, поступившие в УК']} />;
}

export default class LocationList extends DataListComponent<Location> {
    renderNoData() {
        return noDataRenderer();
    }

    buildItemPaper(x: Location, i: number) {
        return buildLocationListItem(x);
    }
}